import {TabActivatorService} from "./tab-activator.service";

export class TopTabActivatorService extends TabActivatorService {

  constructor() {
    super();
  }
}
